import { render, staticRenderFns } from "./ReceiveBillReport.vue?vue&type=template&id=fc2ef022&"
import script from "./ReceiveBillReport.vue?vue&type=script&lang=js&"
export * from "./ReceiveBillReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports